import {getDomainName} from '../../../utils/url'
import {cookieSecuritySettings} from '../../utils/cookies/cookieSecuritySettings'
import {isBrowser} from '../../utils/environment'

const maxAge = 1 // 1 day
const name = 'userCity'

const config = {
  name,
  options: {
    maxAge,
    domain: !isBrowser ? '' : getDomainName(window.location.hostname),
    ...cookieSecuritySettings(true)
  }
}

export default config
